// ComplianceBanner — T2.16c. Zeigt abgelaufene/bald ablaufende
// Bescheinigungen oberhalb der Counter-Row. Nur sichtbar wenn relevant.

import { Link } from "react-router-dom";

import { BescheinigungenResponse, BescheinigungItem } from "../../lib/api";

const TYP_LABEL: Record<string, string> = {
  steuersachen: "Steuersachen-Bescheinigung",
  freistellung_48b: "Freistellung §48b",
  gewerbe: "Gewerbeschein",
  soka: "SOKA-Bau",
  bg: "BG-Bescheinigung",
  sonstige: "Bescheinigung",
};

interface Props {
  data?: BescheinigungenResponse;
}

export default function ComplianceBanner({ data }: Props) {
  if (!data) return null;
  const expired = data.items.filter(
    (b: BescheinigungItem) =>
      b.days_until_expiry !== null && b.days_until_expiry < 0,
  );
  const expiringSoon = data.items.filter(
    (b: BescheinigungItem) =>
      b.days_until_expiry !== null
      && b.days_until_expiry >= 0
      && b.days_until_expiry <= 30,
  );
  if (expired.length === 0 && expiringSoon.length === 0) return null;

  // Sprint 7 Push 1B: 1-Zeilen-Compact-View pro Item statt 3-Zeilen-Block.
  // Erklär-Text in Tooltip. Severity-Trio statt rose/amber-Mix.
  const tooltip =
    "Compliance-Bescheinigungen mit Ablaufdatum. Bei Ablauf: Folge-Aktion in " +
    "Decision-Queue, Steuerberater anschreiben.";

  return (
    <section
      className="rounded-xl border border-pink-500/30 bg-pink-500/[0.06] p-3 flex flex-col gap-1"
      role="alert"
      title={tooltip}
    >
      <h3 className="text-[10px] font-semibold uppercase tracking-wider text-pink-300">
        Compliance-Frist
      </h3>
      <ul className="space-y-1">
        {expired.map((b) => (
          <li key={b.id} className="text-xs text-white flex items-baseline justify-between gap-2">
            <span className="truncate flex-1">
              {TYP_LABEL[b.typ] ?? b.typ} · {b.firma_display}
            </span>
            <span className="text-[10px] tabular-nums text-pink-300 shrink-0">
              {Math.abs(b.days_until_expiry!)} T überfällig
            </span>
          </li>
        ))}
        {expiringSoon.map((b) => (
          <li key={b.id} className="text-xs text-white flex items-baseline justify-between gap-2">
            <span className="truncate flex-1">
              {TYP_LABEL[b.typ] ?? b.typ} · {b.firma_display}
            </span>
            <span className="text-[10px] tabular-nums text-amber-300 shrink-0">
              in {b.days_until_expiry} T
            </span>
          </li>
        ))}
      </ul>
      <Link
        to="/decisions"
        className="text-[10px] text-sky-300/80 hover:text-sky-200 mt-1 self-start"
      >
        → Decision-Queue
      </Link>
    </section>
  );
}
